import React from 'react';
import { useOutletContext } from 'react-router-dom';

const LiveForm = () => {
  const { selectedExchange, mode } = useOutletContext();

  return (
    <div className="p-4 bg-gray-900 text-white">
      <h3 className="text-lg font-semibold mb-4">Connect {selectedExchange.name} Account</h3>
      <div className="p-4 bg-gray-800 rounded-lg mb-4">
        <p className="text-purple-400 mb-2">
          How to create and connect {selectedExchange.name} API Key{' '}
          <span className="text-blue-400">Full Guide</span>
        </p>
        <ol className="list-decimal list-inside text-gray-300 mb-2">
          <li>Log in to your {selectedExchange.name} account and go to API Settings</li>
          <li>Activate IP whitelisting and copy/paste the list of IP addresses below</li>
          <li>Make sure you apply the correct permissions for trading on Spot and/or Futures.</li>
          <li>Fill in all the fields like "API Key" and "Secret", in the form below.</li>
        </ol>
      </div>
      <div className="space-y-4">
        <input
          type="text"
          placeholder="Account Label (Spot)"
          defaultValue={`${selectedExchange.name}`}
          className="w-full p-2 bg-gray-700 rounded"
        />
        <div className="flex space-x-4">
          <input type="text" placeholder="API Key" className="w-1/2 p-2 bg-gray-700 rounded" />
          <input type="text" placeholder="Secret" className="w-1/2 p-2 bg-gray-700 rounded" />
        </div>
        <div className="flex items-center space-x-2">
          <input type="radio" name="accountType" defaultChecked className="text-blue-600" />
          <span>Enable Spot Account</span>
          <input type="radio" name="accountType" className="text-blue-600 ml-4" />
          <span>Enable Futures Account</span>
        </div>
        <p className="text-blue-400 text-sm">
          The IP Whitelist contains the IP addresses used by Altrady. Make sure to add ALL 20 IP addresses to the API key whitelist of the exchange. For more information click on the documentation link above.
        </p>
        <div className="flex justify-between">
          <a href="#" className="text-blue-400">Click here to create a {selectedExchange.name} account</a>
          <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveForm;